import groupBy from "lodash-es/groupBy";
import { IDataProvider } from "motw_core/Data/IDataProvider";
import IDream from "../Entity/IDream";
import { dreamService } from "./DreamService";
import { EDA } from "motw_core/Dreams/EDreamAttribute";

const DreamBoardService = () => {
    const GetPositionFromString = (input: string) => {
        const matches = input.match(/.*\[(.*)\].*/);

        if (matches === null) {
            return undefined;
        }

        return matches[1];
    };

    const GetStringWithUpdatedPosition = (input: string, newPosition: string) =>
        !GetPositionFromString(input)
            ? `${input} [${newPosition}]`
            : input.replace(/(.*\[)(.*)(\].*)/, `$1${newPosition}$3`);

    const GetStringWithoutPosition = (input: string) =>
        input.replace(/(.*)(\[.*\])(.*)/, `$1$3`).trim();

    const UpdateBoardPositionAsync = async (
        dream: IDream,
        newPosition: string,
        dataProvider: IDataProvider
    ) => {
        const newDreamName = GetStringWithUpdatedPosition(
            dream.name,
            newPosition
        );

        const updatedDream = { ...dream, name: newDreamName };
        await dreamService.UpdateDreamAsync(updatedDream, dataProvider);
    };

    const GetGroupedPieces = (dreams: IDream[]) => {
        const piecesToRender = dreams.map((dream) => ({
            dream,
            position: GetPositionFromString(dream.name),
        }));

        const groupedPieces = groupBy(
            piecesToRender,
            (piece) => piece.position
        );

        return groupedPieces;
    };

    const GetRowNumberFromSquareName = (squareName?: string) =>
        squareName ? Number.parseInt(squareName[1]) : undefined;

    const IsDarkSquare = (squareName?: string) => {
        const colLetter = squareName![0];
        const rowNumber = GetRowNumberFromSquareName(squareName)!;

        const columnIndex = colLetter.charCodeAt(0) - "a".charCodeAt(0);
        const total = rowNumber + columnIndex;

        return total % 2 === 0;
    };

    const GetEnemyLineRowNumber = (dreams: IDream[]) => {
        const enemyPieces = dreams.filter((dream) =>
            dreamService.DoesDreamHaveAttribute(dream, EDA.problem)
        );

        const enemyRowNumbers = enemyPieces
            .map((dream) => GetPositionFromString(dream.name))
            .map((position) =>
                position ? GetRowNumberFromSquareName(position) : undefined
            )
            .filter((rowNumber) => rowNumber !== undefined) as number[];

        const result = Math.min(...enemyRowNumbers);
        return result;
    };

    const GetHeroLineRowNumber = (dreams: IDream[]) => {
        const heroPieces = dreams.filter(
            (dream) =>
                !dreamService.DoesDreamHaveAttribute(
                    dream,
                    EDA.problem
                )
        );

        const heroRowNumbers = heroPieces
            .map((dream) => GetPositionFromString(dream.name))
            .map((position) =>
                position ? GetRowNumberFromSquareName(position) : undefined
            )
            .filter((rowNumber) => rowNumber !== undefined) as number[];

        const result = Math.max(...heroRowNumbers);
        return result;
    };

    return {
        GetPositionFromString,
        GetStringWithUpdatedPosition,
        GetStringWithoutPosition,
        UpdateBoardPositionAsync,
        GetGroupedPieces,
        GetRowNumberFromSquareName,
        IsDarkSquare,
        GetEnemyLineRowNumber,
        GetHeroLineRowNumber,
    };
};

export const dreamBoardService = DreamBoardService();
